import { ActionReducer, INIT, UPDATE } from '@ngrx/store';

/**
 * Meta-reducer to sync auth state with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    // 1. Get the next state
    const nextState = reducer(state, action);

    // 2. If it's the initial load, try to hydrate from localStorage
    if (action.type === INIT || action.type === UPDATE) {
      const savedState = localStorage.getItem('__auth_storage__');
      if (savedState) {
        return { ...nextState, auth: JSON.parse(savedState) };
      }
    }

    // 3. If the auth state changed, save it
    if (nextState?.auth) {
      localStorage.setItem('__auth_storage__', JSON.stringify(nextState.auth));
    }

    return nextState;
  };
}
